<template>
  <action-dispatcher
    action="user/get"
    @error="logoutWithNextRoute"
    class="template-default d-flex flex-column"
    :class="`theme-${$setup.theme}`"
    @success="setBackground"
  >
    <transition name="fade">
      <div class="blocking-bg d-lg-none" v-if="showMenu" @click="closeMenu" />
    </transition>

    <nav :class="{ blur: showMenu }">
      <div class="container-fluid h-100 d-flex align-items-center">
        <button
          class="btn btn-menu p-0"
          :class="{ show: showMenu }"
          @click.stop="clickMenuButton"
        >
          <i class="menu" :class="showMenu ? 'icon-close' : 'icon-menu'"></i>
        </button>
        <div class="flex-fill"></div>
        <router-link
          v-if="!searchVisible"
          :to="{ name: 'home' }"
          class="brand mr-5"
        >
          <div class="img" :style="styles" />
        </router-link>
        <div class="d-flex align-items-center justify-content-end">
          <search @open="searchVisible = true" @close="searchVisible = false" />
          <!-- <notifications-dropdown v-if="!searchVisible" /> -->
          <profile-dropdown
            v-if="!searchVisible"
            @logout="logoutDialog = true"
            @faq="faqDialog = true"
            @support="supportDialog = true"
            toggleClasses="nav-size pr-0"
          />
        </div>
      </div>
    </nav>

    <confirmation
      v-model="logoutDialog"
      @confirm="logout"
      text="Tem certeza que deseja sair?"
      confirm-button-text="Sair"
    />

    <action-dispatcher action="modules/getAll" class="flex-fill">
      <aside-menu
        v-model="showMenu"
        @close="closeMenu"
        @logout="logoutDialog = true"
      />

      <main class="flex-fill">
        <div class="position-relative slot-wrapper">
          <slot v-if="!loading" />
          <b-spinner variant="primary" v-else />
        </div>
      </main>
    </action-dispatcher>

    <app-footer class="mt-5" @logout="logoutDialog = true" />

    <faq-modal v-model="faqDialog" />
    <support-modal v-model="supportDialog" />

    <transition name="fade">
      <div class="backdrop" v-if="showMenu" @click="showMenu = false"></div>
    </transition>
  </action-dispatcher>
</template>

<script>
import AppFooter from "@/components/templates/AppFooter";
import AsideMenu from "@/components/templates/AsideMenu";
import FaqModal from "@/components/templates/FaqModal";
// import NotificationsDropdown from "@/components/templates/NotificationsDropdown";
import ProfileDropdown from "@/components/templates/ProfileDropdown";
import Search from "@/components/templates/Search";
import SupportModal from "@/components/templates/SupportModal";
import { mapState } from "vuex";

export default {
  components: {
    // NotificationsDropdown,
    ProfileDropdown,
    SupportModal,
    AsideMenu,
    AppFooter,
    FaqModal,
    Search
  },
  data() {
    return {
      searchVisible: false,
      faqDialog: false,
      supportDialog: false,
      popupDialog: false,
      showMenu: false,
      logoutDialog: false,
      menuButtonTimeout: null
    };
  },
  computed: {
    ...mapState(["loading"]),
    styles() {
      if (this.$setup.setup.logo)
        return `background-image: url(${this.$setup.setup.logo})`;

      return `background-image: url(${this.$setup.partnerLogo})`;
    }
  },
  methods: {
    clickMenuButton() {
      this.setMenuVisibility(!this.showMenu);
    },
    setMenuVisibility(visibility) {
      if (this.menuButtonTimeout) {
        clearTimeout(this.menuButtonTimeout);
      }
      this.menuButtonTimeout = setTimeout(() => {
        this.showMenu = visibility;
      }, 150);
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push({ name: "login" });
      });
    },
    logoutWithNextRoute() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push({
          name: "login",
          query: { next: this.$route.fullPath }
        });
      });
    },
    closeMenu() {
      this.showMenu = false;
    },
    setBackground() {
      if (this.$setup.setup.config.style == "light") {
        document.body.setAttribute("style", "background-color: #dddee6;");
      } else {
        document.body.setAttribute("style", "background-color: #fff;");
      }
    }
  },
  mounted() {
    this.$store.dispatch("courses/getGroups");
    this.$store.dispatch("modules/getFAQ");
  }
};
</script>

<style lang="scss" scoped>
.template-default {
  min-height: 100vh;
  display: flex;
  .blur {
    -webkit-filter: blur(5px);
  }
  .nav-size {
    width: 0px !important;
    min-width: 0px !important;
  }

  .btn-menu {
    width: 0px;
    min-width: 0px;
    height: 72px;
    z-index: 10;
    position: fixed;
    left: 34px;
    @media screen and (min-width: 992px) {
      left: 100px;
    }

    &.show {
      i {
        color: white !important;
        border-radius: 6px;
      }
    }
  }

  .blocking-bg {
    position: fixed;
    z-index: 3;
    background: rgba(0, 10, 20, 0.5);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  i {
    font-size: 24px;
    min-width: 46px;

    &.menu {
      font-size: 32px;
      line-height: 44px;
      color: rgba(51, 51, 51, 0.6);
    }
  }

  main {
    width: 100%;
    position: relative;
    // margin-top: 72px;
  }

  nav {
    display: flex;
    align-items: center;
    min-height: 72px;
    max-height: 72px;
    width: 100%;
    top: 0;
    flex: 1 1 auto;
    position: fixed;
    background: linear-gradient(black, rgba(0, 0, 0, 0));
    z-index: 9999;

    ::v-deep .btn {
      color: white;
      font-size: 12px;
    }

    @media screen and (max-width: 575px) {
      right: 0;
      top: 0;
      left: 0;
      z-index: 3;
      position: fixed;
    }

    .brand {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);

      @media screen and (max-width: 540px) {
        left: 20%;
        transform: translateX(-10%) translateY(-50%);
      }

      .img {
        height: 40px;
        width: 160px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position-x: center;
        background-position-y: center;
      }
    }

    i {
      font-size: 20px;
    }
  }

  .slot-wrapper {
    transition: 0.3s padding ease;
  }

  .backdrop {
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(5px);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.2s ease;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
